


















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "@/components/dialog/index.vue";
import swiper from "../../swiper.vue";
import { Button } from "mint-ui";

@Component<VBANNER>({
  components: {
    dialogComp,
    "mt-button": Button,
    swiper
  },
  props: ["hideCloseBtn","chinaCity","audioPlayStatus"],
  data() {
    return {
      
      travelData: [
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/1.jpg",
          title: "3天2夜，玩转四季风景如画的江原道",
          content: "南怡岛的秋天将周边染成一片金黄，为游客呈现出如梦幻般的秋季景色。",
          link: "https://touch.travel.qunar.com/youji/7724987?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/2.jpg",
          title: "好友首尔两日趴趴走",
          content: "江南的狎鸥亭、清潭洞、论岘洞是众多明星居住的小区，也是大大小小的演艺企划公司密集的区域。",
          link: "https://touch.travel.qunar.com/youji/7724668?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/3.jpg",
          title: "恋人未满——首尔两日浪漫游",
          content: "你看过韩国电视剧《阳光先生（tvN，2018）》吗？在以20世纪初开化期的朝鲜为背景拍摄的电视剧里，一度成为热门话题的便是充满开化期浪漫色彩的主人公服饰。",
          link: "https://touch.travel.qunar.com/youji/7724755?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/4.jpg",
          title: "首尔一日美妆之旅",
          content: "这里几乎囊括了大多的化妆产品哦，价格便宜，所以如果喜欢化妆的话，一定要来看看哦！",
          link: "https://touch.travel.qunar.com/youji/7724768?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/5.jpg",
          title: "舌尖上的釜山美食两日游",
          content: "旅游除了去看风景外，还得去寻找当地的名食来满足自已的舌尖，来釜山就一定要来这些地方尝一尝！",
          link: "https://touch.travel.qunar.com/youji/7724842?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/6.jpg",
          title: "奢华釜山二日游",
          content: "釜山是世界上最繁忙的港口之一，历史上一直都是东亚大陆和海洋文化交流的纽带和桥梁。在这里你可以感受最高档的海洋休闲项目逛最具创意的画廊，品尝美食畅饮美酒的同时还可以俯瞰釜山美丽的海边夜景。",
          link: "https://touch.travel.qunar.com/youji/7724846?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/7.jpg",
          title: "与恋人开启浪漫济州二日游",
          content: "很喜欢济州岛这座城市，它也带给我很多意想不到的惊喜。但是我相信以后不管谁问我，济州岛怎么样啊，有意思吗，我都会说，这个城市值得来。",
          link: "https://touch.travel.qunar.com/youji/7724857?bd_source=RN&showType=share"
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/8.jpg",
          title: "与家人开启美好济州二日之旅",
          content: "和家人一起出去玩,最重要就是舒适的感觉,济州岛一个大小老少都可以来得地方。",
          link: "https://touch.travel.qunar.com/youji/7725269?bd_source=RN&showType=share"
        }
      ],
    }
  }
})
export default class VBANNER extends Vue {
  public chinaCity:string = '';
  public audioPlayStatus:boolean = false;
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public goUrl() {
    location.href =
      "https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong";
  }

  public closeDialog() {
    this.close()
  }
}
